import request from '@/utils/request'
import axios from 'axios'
import Vue from 'vue'

//打包配置文件
function getServerUrl() {
    var urlArr = Vue.prototype.urlArr;
    if (!urlArr) {
        axios.get('static/urlconfig/serverConfig.json').then(res => {
            urlArr = res.data;
            Vue.prototype.urlArr = res.data;
            return urlArr;
        })
    } else {
        return urlArr
    }
}

/*
 * 封装公用请求方法
 *
 * Yvan
 *
 * 2019-4-25
 */
// 验证码文件流转图片ajax-登录页
export function amountList1(url, obj) {
    var getUrl = getServerUrl();
    return request({
        url: getUrl.baseUrl + url,
        method: 'post',
        responseType: "arraybuffer",
        xhrFields: {
            withCredentials: true
        },
        crossDomain: true,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
        data: obj
    })
}
//六期平台教育局用户区分
export function ajaxFuncJsonLogin(url, obj) {
    var getUrl = getServerUrl();
    return request({
        url: getUrl.baseUrl + url,
        method: 'post',
        xhrFields: {
            withCredentials: true
        },
        crossDomain: true,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        },
        data: obj

    })
}
// 公用ajax-基本用法
export function ajaxFuncJson(url, obj) {
    var getUrl = getServerUrl();
    if (sessionStorage.getItem('userType') == 3 || sessionStorage.getItem('userType') == 4) { //教育局
        return request({
            url: getUrl.baseUrl + '/bureau' + url,
            method: 'post',
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            data: obj
        })
    } else {
        return request({
            url: getUrl.baseUrl + url,
            method: 'post',
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            data: obj

        })
    }
}
// 上传回显ip
export function uploadIp() {
    var uploadIp = getServerUrl().uploadUrl;
    return uploadIp;
}

//文件上传ip
export function upFileIp() {
    var upFileIp = getServerUrl().uploadUrl + '/file/uploadFile';
    return upFileIp;
}
//文件上传ip公告
export function uploadNoticeFile() {
    var upFileIp = getServerUrl().uploadUrl + '/file/uploadNoticeFile';
    return upFileIp;
}

// webSocket
export function SocketUrl() {
    var SocketUrl = getServerUrl().webSocketUrl;
    return SocketUrl;
}

// 站点统计
export function webId() {
    var webId = getServerUrl().webId;
    return webId;
}


// WEBPACK FOOTER //
// ./src/api/ajax.js